import { analysisOneDimTableBuilder } from './BAnalysisOneDimTable'

export const BAnalysisLineTable = analysisOneDimTableBuilder('BAnalysisLineTable')
